import { Navigate, useSearchParams } from 'react-router-dom';

/** Preserve old bookmarks and full-page checkout returns after moving installation into each method. */
export default function LegacySetupRedirect() {
  const [params] = useSearchParams();
  let method = params.has('gatewayTarget') || params.get('method') === 'gateway' ? 'gateways'
    : params.has('agentTarget') || params.get('method') === 'agent' ? 'agents' : null;
  if (params.has('payment')) {
    try {
      const saved = JSON.parse(localStorage.getItem('wiz_state') || '{}');
      method = saved.gatewayMode ? 'gateways' : 'agents';
    } catch { method ??= 'agents'; }
  }
  return <Navigate to={method ? `/dashboard/${method}/install?${params}` : '/dashboard?install=choose'} replace />;
}
